import { render, staticRenderFns } from "./Slide5.vue?vue&type=template&id=552f72f7&scoped=true&"
import script from "./Slide5.vue?vue&type=script&lang=ts&"
export * from "./Slide5.vue?vue&type=script&lang=ts&"
import style0 from "./Slide5.vue?vue&type=style&index=0&id=552f72f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f72f7",
  null
  
)

export default component.exports